import { useLayoutEffect, useRef } from 'react';

/**
 * Open the session sidebar while Voice is in the RHS slot; close it when Voice
 * leaves so Work/Ask Heidi does not flash underneath. Does not restore a
 * prior open Ask Heidi / Work panel (see PR notes).
 *
 * Unmount while hosting also closes — Sync can disappear when Ask Heidi / Work
 * gates flip off; leaving the sidebar open would show an empty RHS while
 * placement falls back to overlay.
 */
export function useVoiceHostedSidebarOpen(
  voiceInHost: boolean,
  setOpen: (open: boolean) => void
) {
  const wasHostingRef = useRef(false);
  const setOpenRef = useRef(setOpen);
  setOpenRef.current = setOpen;

  useLayoutEffect(() => {
    if (voiceInHost) {
      wasHostingRef.current = true;
      setOpen(true);
      return;
    }
    if (wasHostingRef.current) {
      wasHostingRef.current = false;
      setOpen(false);
    }
  }, [voiceInHost, setOpen]);

  useLayoutEffect(
    () => () => {
      if (wasHostingRef.current) {
        wasHostingRef.current = false;
        setOpenRef.current(false);
      }
    },
    []
  );
}
